function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.125 4.375V6.625H5.375V4.375H3.125ZM2 4.375C2 3.76562 2.51562 3.25 3.125 3.25H5.375C6.00781 3.25 6.5 3.76562 6.5 4.375V4.9375H9.5V4.375C9.5 3.76562 10.0156 3.25 10.625 3.25H12.875C13.5078 3.25 14 3.76562 14 4.375V6.625C14 7.25781 13.5078 7.75 12.875 7.75H10.625C10.0156 7.75 9.5 7.25781 9.5 6.625V6.0625H6.5V6.625C6.5 6.85938 6.42969 7.09375 6.28906 7.28125L7.76562 9.25H9.875C10.5078 9.25 11 9.76562 11 10.375V12.625C11 13.2578 10.5078 13.75 9.875 13.75H7.625C7.01562 13.75 6.5 13.2578 6.5 12.625V10.375C6.5 10.1406 6.57031 9.90625 6.71094 9.71875L5.23438 7.75H3.125C2.51562 7.75 2 7.25781 2 6.625V4.375ZM7.625 10.375V12.625H9.875V10.375H7.625ZM12.875 4.375H10.625V6.625H12.875V4.375Z",
  fill: "#636766"
});

function SvgMappingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappingIcon);
export default __webpack_public_path__ + "static/media/mapping-icon.d472b2b3.svg";
export { ForwardRef as ReactComponent };